import { css } from '@styled-system/css';
import { X } from 'lucide-react';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

// ============================================================================
// Bandeau pleine largeur en haut de l'app : accès à l'ancienne version
// (Recop v1, archive.recop.app). Fermable d'une croix — choix persisté.
// ============================================================================

const DISMISS_KEY = 'legacyBanner.dismissed';

// Superposée à la page (fixed) : elle ne décale pas le layout, elle flotte
// au-dessus du contenu jusqu'à sa fermeture.
const banner = css({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '2',
  paddingY: '3',
  paddingX: '12',
  bg: 'brand.primarySoft',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'brand.primary/40',
  boxShadow: 'sm',
  fontSize: 'bodySm',
  color: 'text.primary',
  textAlign: 'center',
});

const link = css({
  color: 'brand.primary',
  fontWeight: 'semibold',
  textDecoration: 'underline',
  textUnderlineOffset: '2px',
  _hover: { opacity: 0.85 },
});

const closeBtn = css({
  position: 'absolute',
  right: '4',
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '26px',
  height: '26px',
  borderRadius: 'md',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  color: 'text.tertiary',
  _hover: { color: 'text.primary', bg: 'brand.primary/10' },
});

export const LegacyVersionBanner: FC = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return window.localStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try {
      window.localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // stockage indisponible : fermé pour la session seulement
    }
  };

  return (
    <div className={banner}>
      <span>
        {t('nav.legacyBannerText')}{' '}
        <a href="https://archive.recop.app" target="_blank" rel="noopener noreferrer" className={link}>
          archive.recop.app
        </a>
      </span>
      <button type="button" className={closeBtn} onClick={dismiss} aria-label={t('common.close')}>
        <X size={15} strokeWidth={2} />
      </button>
    </div>
  );
};
